export const SearchStat = {
    /** 承認依頼済*/
    ALL: '3',
    /** 承認 */
    SHONINZUMI: '2',
    /** 未承認 */
    mishonin: '1',
} as const;